module.exports = __webpack_public_path__ + "static/img/kef.617cf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kef.png
// module id = SUYu
// module chunks = 1